import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { Badge, FlexCenter, FlexColumn, TableCell, TableRow, TextBody, TextOverflowTooltip, Tooltip } from "@opensea/ui-kit";
import { Info, WarningFilled } from "@opensea/ui-kit/icons";
import { useTranslations } from "use-intl";
import { QUOTE_RECEIPT_TABLE_COLUMN_CLASSNAMES } from "../QuoteReceipt/constants";
import { CollectionSweepQuoteReceiptFragment } from "./CollectionSweepQuoteReceipt.fragment";
import { CollectionSweepQuoteReceiptRange, getPriceRangeFromQuote } from "./CollectionSweepQuoteReceiptRange";
const MAX_PRICE_RANGE_SPREAD = 20;
function getPriceRangeSpread(min, max) {
  if (min === max || max === 0) {
    return 0;
  }
  return (max - min) / max * 100;
}
export const CollectionSweepQuoteReceiptTotal = t0 => {
  const $ = _c(34);
  const {
    maxAmountOfItems,
    quote: quoteKey
  } = t0;
  const quote = readFragment(CollectionSweepQuoteReceiptFragment, quoteKey);
  const t = useTranslations("wallet.CollectionSweepFlow");
  const priceRange = getPriceRangeFromQuote(quote, maxAmountOfItems, _temp);
  const priceRangeSpread = getPriceRangeSpread(priceRange.min, priceRange.max);
  const warnWideQuoteSpread = priceRangeSpread > MAX_PRICE_RANGE_SPREAD;
  let t1;
  if ($[0] !== t) {
    t1 = t("total");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <TextOverflowTooltip><TextBody>{t1}</TextBody></TextOverflowTooltip>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("tooltipUpperPriceRange1");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <TextBody size="sm">{t3}</TextBody>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t || $[9] !== warnWideQuoteSpread) {
    t5 = warnWideQuoteSpread ? <TextBody className="font-bold" size="sm">{t("wideQuoteSpreadWarning")}</TextBody> : <TextBody className="font-bold" size="sm">{t("tooltipUpperPriceRange2")}</TextBody>;
    $[8] = t;
    $[9] = warnWideQuoteSpread;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== maxAmountOfItems || $[12] !== quote) {
    t6 = <CollectionSweepQuoteReceiptRange inTooltip={true} maxAmountOfItems={maxAmountOfItems} quote={quote} />;
    $[11] = maxAmountOfItems;
    $[12] = quote;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t4 || $[15] !== t5 || $[16] !== t6) {
    t7 = <TextBody className="text-secondary" size="sm"><FlexColumn className="max-w-[260px] gap-2">{t4}{t5}{t6}</FlexColumn></TextBody>;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== priceRangeSpread || $[19] !== t || $[20] !== warnWideQuoteSpread) {
    t8 = warnWideQuoteSpread ? <Badge icon={WarningFilled} variant="warning">{t("wideQuoteSpread", {
        percent: priceRangeSpread.toPrecision(4)
      })}</Badge> : <Info className="size-5" />;
    $[18] = priceRangeSpread;
    $[19] = t;
    $[20] = warnWideQuoteSpread;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t7 || $[23] !== t8) {
    t9 = <Tooltip align="start" content={t7}>{t8}</Tooltip>;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== t2 || $[26] !== t9) {
    t10 = <TableCell className={QUOTE_RECEIPT_TABLE_COLUMN_CLASSNAMES.item}><FlexCenter className="gap-1">{t2}{t9}</FlexCenter></TableCell>;
    $[25] = t2;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== maxAmountOfItems || $[29] !== quote) {
    t11 = <TableCell className={QUOTE_RECEIPT_TABLE_COLUMN_CLASSNAMES.price}><CollectionSweepQuoteReceiptRange maxAmountOfItems={maxAmountOfItems} quote={quote} /></TableCell>;
    $[28] = maxAmountOfItems;
    $[29] = quote;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== t10 || $[32] !== t11) {
    t12 = <TableRow>{t10}{t11}</TableRow>;
    $[31] = t10;
    $[32] = t11;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  return t12;
};
function _temp(item) {
  return item.pricePerItem.token.unit;
}